<template>
  <!-- 发车合同管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:dispatch_contract:addDispatchContract')"
          class="glo_btnItems glo_bgcMainColor"
          @click="transportPlan"
          >新增</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="transportPlan2"
          >修改</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="delBtns()"
          >删除</el-button
        >
        <!-- <el-button class="glo_btnItems">导出 </el-button>
        <el-button class="glo_btnItems" @click="setMyModel"
          >表格设置
        </el-button>-->
        <el-button class="glo_btnItems" @click="printEvent()">打印</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="false"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      @handleCommandBtns="handleCommandBtns"
      :fieldList="fieldList"
      @fildsClick="fildsClick"
    ></mytable>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormREF')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormREF"
          :model="dialogForm"
          label-width="120px"
          :rules="rulesForm"
        >
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItems"
              prop="number"
              label="发车合同编号:"
            >
              <el-input
                v-model="dialogForm.number"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="dispatchId"
              label="发车批次:"
            >
              <el-select v-model="dialogForm.dispatchId" filterable>
                <el-option v-for="dispatch in dispatchs" :key="dispatch.dispatchId" :value="dispatch.dispatchId" :label="dispatch.dispatchNumber">

                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItems tydw"
              prop="shippingCompany"
              label="托运单位:"
            >
              <el-input
                v-model="dialogForm.shippingCompany"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems tydh"
              prop="shippingTel"
              label="托运联系电话:"
            >
              <el-input
                v-model="dialogForm.shippingTel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItems tydw"
              prop="receiptCompany"
              label="收货单位:"
            >
              <el-input
                v-model="dialogForm.receiptCompany"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems tydh"
              prop="receiptPhone"
              label="收货联系电话:"
            >
              <el-input
                v-model="dialogForm.receiptPhone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            class="dialogFormItems"
            prop="startCity"
            label="始发城市:"
          >
            <el-input
              v-model="dialogForm.startCity"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="endCity"
            label="目的城市:"
          >
            <el-input
              v-model="dialogForm.endCity"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="goodsName"
            label="货物名称:"
          >
            <el-input
              v-model="dialogForm.goodsName"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="totalCount"
            label="总件数:"
          >
            <el-input
              v-model="dialogForm.totalCount"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="totalWeight"
            label="总重量:"
          >
            <el-input
              v-model="dialogForm.totalWeight"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="totalVolume"
            label="总体积:"
          >
            <el-input
              v-model="dialogForm.totalVolume"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <div class="itemTydw">
            <el-form-item
              class="dialogFormItemsTime"
              prop="totalTickets"
              label="总票数:"
            >
              <el-input
                v-model="dialogForm.totalTickets"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItemsTime"
              prop="expectedArrivalTime"
              label="预计到达时间:"
            >
              <el-date-picker
                v-model="dialogForm.expectedArrivalTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                default-time="12:00:00"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              class="dialogFormItemsTime"
              prop="requestArrivalTime"
              label="要求到达时间:"
            >
              <el-date-picker
                v-model="dialogForm.requestArrivalTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                default-time="12:00:00"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item
            class="dialogFormItems"
            style="width: 100%"
            prop="carrierCompany"
            label="承运单位:"
          >
            <el-input
              v-model="dialogForm.carrierCompany"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="driverName"
            label="司机姓名:"
          >
            <el-input
              v-model="dialogForm.driverName"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="driverIdcard"
            label="司机身份证号:"
          >
            <el-input
              v-model="dialogForm.driverIdcard"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="driverPhone"
            label="司机联系电话:"
          >
            <el-input
              v-model="dialogForm.driverPhone"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="driverTel"
            label="家庭电话:"
          >
            <el-input
              v-model="dialogForm.driverTel"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="driverAddress"
            label="司机住址:"
          >
            <el-input
              v-model="dialogForm.driverAddress"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="carOwners"
            label="车主姓名:"
          >
            <el-input
              v-model="dialogForm.carOwners"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="drivingLicenseNumber"
            label="行驶证号:"
          >
            <el-input
              v-model="dialogForm.drivingLicenseNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="driverLicenseNumber"
            label="驾驶证号:"
          >
            <el-input
              v-model="dialogForm.driverLicenseNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="engineNumber"
            label="发动机号:"
          >
            <el-input
              v-model="dialogForm.engineNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="carFrameNumber	"
            label="车牌号:"
          >
            <el-input
              v-model="dialogForm.carFrameNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="carModel	" label="车型:">
            <el-input
              v-model="dialogForm.carModel"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="trailerCarNumber"
            label="挂车车牌号:"
          >
            <el-input
              v-model="dialogForm.trailerCarNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="carOwnersAddress"
            label="车主地址:"
          >
            <el-input
              v-model="dialogForm.carOwnersAddress"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="surchargeNumber"
            label="附加费证号:"
          >
            <el-input
              v-model="dialogForm.surchargeNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="operatingNumber"
            label="运营证号:"
          >
            <el-input
              v-model="dialogForm.operatingNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="policyNumber	"
            label="保险单号:"
          >
            <el-input
              v-model="dialogForm.policyNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="peerDriver	"
            label="同行驾驶员:"
          >
            <el-input
              v-model="dialogForm.peerDriver"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="peerDriverLicenseNumber"
            label="同行驾驶证号:"
          >
            <el-input
              v-model="dialogForm.peerDriverLicenseNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="tollNumber"
            label="养路费号:"
          >
            <el-input
              v-model="dialogForm.tollNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="companyAddress"
            label="单位地址:"
          >
            <el-input
              v-model="dialogForm.companyAddress"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="vehicleCompany"
            label="车属单位:"
          >
            <el-input
              v-model="dialogForm.vehicleCompany"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 
          <el-form-item class="dialogFormItems" prop="a6" label="adas:">
            <el-select v-model="dialogForm.a6" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item class="dislogFormTextarea" prop="remarks	" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>-->
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
      :queryCondditionDatas="queryCondditionDatas"
    ></exportCompoent>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
    ></my-print>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import MyPrint from "@/components/print/MyPrint.vue";
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
export default {
  mixins: [tableListNew,exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
    MyPrint,
    mytable,
    queryCondition,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "发车合同管理列表",
        //apiName: "/admin/v3/tms/dispatch/contract/getDispatchContractList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        pageType: "DepartureContractManagement", //页面类型(主要用来区分查询参参数的时间)
      },

      tableHeigth: "75vh", //  表格高度
      pageGroupName: "DepartureContractManagement", //  页面标识
      reportFiledsNumber: "admin_dispatch_contracts_list", // 动态 条件、表头
      Operatewidth: "220px", //操作列的列宽
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "dispatchEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
        {
          name: "详情",
          methods: "dispatchDetail",
          param: 2,
          show: this.dispatchType !== "gan_xian_pei_zai",
        },
        {
          name: "装货",
          methods: "addLoadOrder",
          param: 2,
          show: this.dispatchType === "gan_xian_pei_zai",
        },
        {
          name: "卸货",
          methods: "addUnLoadOrder",
          param: 2,
          show: this.dispatchType === "gan_xian_pei_zai",
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "发车完成",
          command: "finishDispatch",
        },
        {
          name: "发车确认",
          command: "dispatchConfirm",
        },
        {
          name: "车费摊分",
          command: "allocationCarFee",
          param: 1,
        },
      ],
      fieldList: ["dispatchNumber"],
      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        number: "",
        carFrameNumber: "",
        carModel: "",
        carOwners: "",
        carOwnersAddress: "",
        carrierCompany: "",
        companyAddress: "",
        driverAddress: "",
        driverIdcard: "",
        driverLicenseNumber: "",
        driverName: "",
        driverPhone: "",
        driverTel: "",
        drivingLicenseNumber: "",
        endCity: "",
        engineNumber: "",
        expectedArrivalTime: "",
        goodsName: "",
        operatingNumber: "",
        peerDriver: "",
        peerDriverLicenseNumber: "",
        policyNumber: "",
        receiptCompany: "",
        receiptPhone: "",
        remarks: "",
        requestArrivalTime: "",
        shippingCompany: "",
        shippingTel: "",
        startCity: "",
        surchargeNumber: "",
        tollNumber: "",
        totalCount: "1",
        totalVolume: "",
        totalWeight: "",
        trailerCarNumber: "",
        vehicleCompany: "",
      },
      rulesForm: {
        number: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      diaType: "",
      classNameArr: [
        {
          name: "发车合同",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchContractVO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchContractVO",
        dispatchs:[]
    };
  },
  updated() {},
  created() {},
  activated() {},
  mounted() {
    //计算获取表格高度
    // this.fetTableHeight();
    this.getDispatchs()
  },
  watch: {},
  methods: {
    async getDispatchs(){
      const res = await this.$API.runList({
        number:'down_list_dispatch_v5',
        dispatchNumber:''
      })
      this.dispatchs = res
    },
    setMyModel() {
      this.$TOOLS.myModel(this);
    },
    // 新建合同
    transportPlan() {
      this.isShowDialog = true;
      this.dialogTitle = "新建发车合同";
      this.diaType = "add";
    },
    getDetail(){
      this.$API.wtl_getDispatchContractDetail({
        contractId:this.selectTableData[0].contractId
      }).then(res=>{
        this.dialogForm = res.data.result
      })
    },
    async transportPlan2() {
      if(this.selectTableData.length === 0){
        this.$message.warning("请选择需要修改的合同")
        return
      }
      this.WaybillEdit(this.selectTableData[0])
    },
    // 修改合同
    WaybillEdit(row) {
      this.$API
        .wtl_getDispatchContractDetail({ contractId: row.contractId })
        .then((res) => {
          this.dialogForm = res.data.result;
          this.isShowDialog = true;
          this.dialogTitle = "修改发车合同";
          this.diaType = "edit";
        });
    },
    // 删除
    delBtns(val) {
      let ids = [];
      // 右边单选
      if (val) {
        ids.push(val.contractId);
      } else {
        // 上面多选
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.contractId;
        });
      }

      this.$confirm("确定要删除所选合同单吗吗? 请谨慎操作", "提示:")
        .then(() => {
          this.$API
            .wtl_delDispatchContract({ contractIds: ids })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm));
          param.totalCount = param.totalCount || 0;
          param.totalVolume = param.totalVolume || 0;
          param.totalWeight = param.totalWeight || 0;
          if (this.diaType == "add") {
            this.$API.wtl_addDispatchContract(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          } else {
            this.$API.wtl_updateDispatchContract(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
              this.isShowDialog = false;
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
    handleCommandBtns(command, data) {
      this[command](data);
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    //    -------------  设置列表表头方法  ------------
    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
    printDataSource(rows) {
      return new Promise((resolve, reject) => {
        resolve(rows)
      });
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.diaForm {
  .itemsRows {
    width: 100%;
  }

  .itemTydw {
    width: 100%;
    display: flex;
    .tydw {
      flex: 2;
    }

    .tydh {
      flex: 1;
    }
  }
}
</style>
